import BaseResource from './BaseResource'

export default class Products extends BaseResource {
  static endpoint = '/api/v1/products' ///tracking
}
